export const PLATFORM_REPORT_SUMMARY_LOADED="PLATFORM_REPORT_SUMMARY_LOADED";


export const platformSummary=(data)=>(dispatch)=>{
  
    dispatch(({
        type:PLATFORM_REPORT_SUMMARY_LOADED,
        payload:data
    }))
}